module.exports = __webpack_public_path__ + "img/zhiyuanzhe.eccc140c.png";